import React from 'react';
import Layout from '../common/AdminLayout';
import { PatientList } from '../../../components/molecules';

export default function PatientsAdmin(props) {
  return (
      <PatientList {...props} />
  );
}
